import { render, staticRenderFns } from "./StoreInTxt.vue?vue&type=template&id=00d0e5c1&"
import script from "./StoreInTxt.vue?vue&type=script&lang=js&"
export * from "./StoreInTxt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports